import React from 'react';
import { useTranslation } from 'react-i18next';
import { WAREHOUSE_MOVEMENT_INDEX } from '../../../router/routes';
import Title from '../../../components/common/title';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import Deals from './deals';
import Remainders from './remainders';
import ShowIfAllowed from '../../../components/common/show-if-allowed';

export enum MovementType {
  deals = 'deals',
  remainders = 'remainders',
}

export default function Movement() {
  const { t } = useTranslation();
  const [currentTab, setTab] = useTab(WAREHOUSE_MOVEMENT_INDEX, [
    'tab',
    'farmId',
  ]);

  return (
    <>
      <Title title={t('pages.warehouse.movement.title')} />

      <TabContainer
        selectedTabKey={currentTab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <ShowIfAllowed ability={{ title: 'viewAny deal' }}>
              <TabLink tabKey={MovementType.deals}>
                {t('pages.warehouse.deals.title')}
              </TabLink>
            </ShowIfAllowed>
            <ShowIfAllowed ability={{ name: 'viewRemainder' }}>
              <TabLink tabKey={MovementType.remainders}>
                {t('pages.warehouse.remainders.title')}
              </TabLink>
            </ShowIfAllowed>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <ShowIfAllowed ability={{ title: 'viewAny deal' }}>
              <Tab tabKey={MovementType.deals}>
                <Deals />
              </Tab>
            </ShowIfAllowed>
            <ShowIfAllowed ability={{ name: 'viewRemainder' }}>
              <Tab tabKey={MovementType.remainders}>
                <Remainders />
              </Tab>
            </ShowIfAllowed>
          </TabContents>
        }
      />
    </>
  );
}
